/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const deps = ['ConversationSummary', 'AvatarUrl'];

const ConversationBriefCtrl = function (ConversationSummary, AvatarUrl) {
  this.conversation = new ConversationSummary(this.id).$viewModel();

  this.avatarUrl = AvatarUrl.getAvatar;
};

ConversationBriefCtrl.$inject = deps;

module.exports = ConversationBriefCtrl;
